export const SELJAN_SHIFT_TIMES = [
    {
        day: 'Monday',
        shifts: [
            {
                shift: 'third',
                start: { hour: 23, minute: 0 },
                startDay: 'Sunday',
                end: { hour: 7, minute: 0 }
            },
            {
                shift: 'first',
                start: { hour: 7, minute: 0 },
                end: { hour: 15, minute: 30 }
            },
            {
                shift: 'second',
                start: { hour: 15, minute: 30 },
                end: { hour: 23, minute: 0 }
            }
        ]
    },
    {
        day: 'Tuesday',
        shifts: [
            {
                shift: 'third',
                start: { hour: 23, minute: 0 },
                startDay: 'Monday',
                end: { hour: 7, minute: 0 }
            },
            {
                shift: 'first',
                start: { hour: 7, minute: 0 },
                end: { hour: 15, minute: 30 }
            },
            {
                shift: 'second',
                start: { hour: 15, minute: 30 },
                end: { hour: 23, minute: 0 }
            }
        ]
    },
    {
        day: 'Wednesday',
        shifts: [
            {
                shift: 'third',
                start: { hour: 23, minute: 0 },
                startDay: 'Tuesday',
                end: { hour: 7, minute: 0 }
            },
            {
                shift: 'first',
                start: { hour: 7, minute: 0 },
                end: { hour: 15, minute: 30 }
            },
            {
                shift: 'second',
                start: { hour: 15, minute: 30 },
                end: { hour: 23, minute: 0 }
            }
        ]
    },
    {
        day: 'Thursday',
        shifts: [
            {
                shift: 'third',
                start: { hour: 23, minute: 0 },
                startDay: 'Wednesday',
                end: { hour: 7, minute: 0 }
            },
            {
                shift: 'first',
                start: { hour: 7, minute: 0 },
                end: { hour: 15, minute: 30 }
            },
            {
                shift: 'second',
                start: { hour: 15, minute: 30 },
                end: { hour: 23, minute: 0 }
            }
        ]
    },
    {
        day: 'Friday',
        shifts: [
            {
                shift: 'third',
                start: { hour: 23, minute: 0 },
                startDay: 'Thursday',
                end: { hour: 7, minute: 0 }
            },
            {
                shift: 'first',
                start: { hour: 7, minute: 0 },
                end: { hour: 15, minute: 30 }
            },
            {
                shift: 'second',
                start: { hour: 15, minute: 30 },
                end: { hour: 23, minute: 0 }
            }
        ]
    }
];